import { FaceRect } from '@d-id/types';
import { ImageElementType } from 'polotno/model/image-model';

export const getCloseupFaceData = (avatarElement: ImageElementType | undefined, faceRect: FaceRect | undefined | null) => {
    const padding = 1.4;
    if (!faceRect) return;

    const imageWidth = avatarElement?.custom?.originalWidth;
    const imageHeight = avatarElement?.custom?.originalHeight;
    const aspectRatio = imageWidth / imageHeight;

    const { top, left, bottom, right } = faceRect;

    // Calculate the face rectangle dimensions
    const faceWidth = right - left;
    const faceHeight = bottom - top;

    // Calculate face center
    const faceCenterX = left + faceWidth / 2;
    const faceCenterY = top + faceHeight / 2;

    // Calculate max face dimension with padding
    const faceMax = Math.max(faceWidth, faceHeight) * (1 + padding);

    // Calculate crop dimensions maintaining aspect ratio
    let cropWidth, cropHeight;

    if (aspectRatio >= 1) {
        // Horizontal or square image
        if (faceWidth > faceHeight) {
            // Face is wider than tall
            cropWidth = faceMax;
            cropHeight = cropWidth / aspectRatio;
        } else {
            // Face is taller than wide
            cropHeight = faceMax;
            cropWidth = cropHeight * aspectRatio;
        }
    } else {
        // Vertical image
        if (faceWidth > faceHeight) {
            // Face is wider than tall
            cropWidth = faceMax;
            cropHeight = cropWidth / aspectRatio;
        } else {
            // Face is taller than wide
            cropHeight = faceMax;
            cropWidth = cropHeight * aspectRatio;
        }
    }

    // Ensure crop dimensions don't exceed image dimensions
    cropWidth = Math.min(cropWidth, imageWidth);
    cropHeight = Math.min(cropHeight, imageHeight);

    // Calculate crop center, ensuring it's within image bounds
    const cropCenterX = Math.max(Math.min(faceCenterX, imageWidth - cropWidth / 2), cropWidth / 2);
    const cropCenterY = Math.max(Math.min(faceCenterY, imageHeight - cropHeight / 2), cropHeight / 2);

    // Calculate new crop rectangle
    const cropLeft = cropCenterX - cropWidth / 2;
    const cropTop = cropCenterY - cropHeight / 2;

    // Convert to crop tool format (normalized to 0-1 scale)
    const cropXRatio = cropLeft / imageWidth;
    const cropYRatio = cropTop / imageHeight;
    const cropWidthRatio = cropWidth / imageWidth;
    const cropHeightRatio = cropHeight / imageHeight;

    return {
        cropXRatio,
        cropYRatio,
        cropWidth,
        cropHeight,
        cropWidthRatio,
        cropHeightRatio,
    };
};
